<template>
    <div class="station-card" :class="{selected: selected}">
        <div style="width: -webkit-fill-available;">
            <div class="station-picture">
                <v-img :src="station.photolink" contain style="border-radius: 12px;" />
            </div>
            <div class="station-description">
                <div class="station-description-title">
                    {{ station.name }}
                </div>
                <div class="station-description-text">
                </div>
                <div class="station-description-time">
                    {{ station.worktime }}
                </div>
            </div>
        </div>
        <div class="station-actions" v-if="view">
            <v-btn
                @click="showOnMap"
                elevation="0"
                class="station-select-btn view"
                :style="{'max-width': station.phone ? '80%' : '100%', 'width': station.phone ? '80%' : '100%'}"
            >
                <span class="btn-text">Показать на карте</span>
            </v-btn>
            <v-btn
                v-if="station.phone"
                icon
                elevation="0"
                class="station-map-btn view"
                @click="showOnMap"
            >
                <svg width="18.750000" height="18.749466" viewBox="0 0 18.75 18.7495" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs/>
                    <path id="Vector" d="M12.7578 11.2526C12.8828 11.2413 13.0078 11.2611 13.125 11.3104L17.543 13.2913C17.6953 13.355 17.8164 13.4652 17.8984 13.6055C17.9805 13.7458 18.0117 13.9086 17.9961 14.0695C17.8477 15.1579 17.3125 16.1565 16.4844 16.8794C15.6602 17.6023 14.5977 18.0003 13.5 17.9995C10.1172 17.9995 6.875 16.6562 4.48438 14.2651C2.09375 11.874 0.75 8.63097 0.75 5.24947C0.75 4.15128 1.14844 3.09016 1.87109 2.26346C2.59375 1.43675 3.58984 0.900742 4.67969 0.755081C4.83984 0.735977 5.00391 0.769485 5.14453 0.850601C5.28516 0.931717 5.39453 1.05609 5.45703 1.20508L7.4375 5.63008C7.48828 5.74374 7.50781 5.86766 7.49609 5.99083C7.48438 6.11398 7.44531 6.23257 7.37891 6.33603L5.375 8.71822C5.30078 8.82544 5.26172 8.94928 5.25 9.07762C5.24219 9.20596 5.26562 9.33441 5.32422 9.45039C6.09766 11.0376 7.73828 12.6585 9.33203 13.4263C9.44922 13.4817 9.57812 13.5058 9.70703 13.496C9.83594 13.4864 9.95703 13.4433 10.0664 13.371L12.4102 11.3751C12.5156 11.306 12.6367 11.2639 12.7578 11.2526Z" stroke="#DA251C" stroke-opacity="1.000000" stroke-width="1.500000" stroke-linejoin="round"/>
                </svg>
            </v-btn>
        </div>
        <div class="station-actions" v-else>
            <v-btn
                @click="selectStation"
                elevation="0"
                class="station-select-btn"
                :class="{selected: selected}"
                :disabled="selected"
            >
                <span v-if="!selected" class="btn-text">Выбрать</span>
                <span v-else class="btn-text">Выбрано</span>
            </v-btn>
            <v-btn
                icon
                elevation="0"
                class="station-map-btn"
                @click="showOnMap"
            >
                <svg width="15.125000" height="19.250000" viewBox="0 0 15.125 19.25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs/>
                    <path id="Vector" d="M13.75 17.875L9.5 17.875C10.2139 17.2373 10.8867 16.5557 11.5156 15.834C13.875 13.1211 15.125 10.2607 15.125 7.5625C15.125 5.55664 14.3281 3.63281 12.9102 2.21484C11.4922 0.796875 9.56836 0 7.5625 0C5.55664 0 3.63281 0.796875 2.21484 2.21484C0.796875 3.63281 0 5.55664 0 7.5625C0 10.2607 1.24707 13.1211 3.60938 15.834C4.23828 16.5557 4.91113 17.2373 5.625 17.875L1.375 17.875C1.19238 17.875 1.01758 17.9473 0.888672 18.0762C0.759766 18.2051 0.6875 18.3799 0.6875 18.5625C0.6875 18.7451 0.759766 18.9199 0.888672 19.0488C1.01758 19.1777 1.19238 19.25 1.375 19.25L13.75 19.25C13.9326 19.25 14.1074 19.1777 14.2363 19.0488C14.3652 18.9199 14.4375 18.7451 14.4375 18.5625C14.4375 18.3799 14.3652 18.2051 14.2363 18.0762C14.1074 17.9473 13.9326 17.875 13.75 17.875ZM7.5625 4.8125C8.10645 4.8125 8.6377 4.97363 9.08984 5.27637C9.54297 5.57812 9.89551 6.00781 10.1035 6.50977C10.3115 7.0127 10.3662 7.56543 10.2598 8.09863C10.1533 8.63281 9.8916 9.12207 9.50684 9.50684C9.12207 9.8916 8.63281 10.1533 8.09863 10.2598C7.56543 10.3662 7.0127 10.3115 6.50977 10.1035C6.00781 9.89551 5.57812 9.54297 5.27637 9.08984C4.97363 8.6377 4.8125 8.10645 4.8125 7.5625C4.8125 6.83301 5.10254 6.13379 5.61816 5.61816C6.13379 5.10254 6.83301 4.8125 7.5625 4.8125Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                </svg>

            </v-btn>
        </div>
        <v-dialog
            v-if="isShownMapDialog"
            v-model="isShownMapDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <div>
                <v-card tile class="dialog-card">
                    <div>
                        <v-toolbar
                            flat
                        >
                            <v-toolbar-title>{{station.name}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                @click="isShownMapDialog = false"
                            >
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M32.251 30.2926C32.3439 30.3855 32.4176 30.4958 32.4679 30.6172C32.5182 30.7386 32.5441 30.8687 32.5441 31.0001C32.5441 31.1315 32.5182 31.2616 32.4679 31.383C32.4176 31.5044 32.3439 31.6147 32.251 31.7076C32.1581 31.8005 32.0478 31.8742 31.9264 31.9245C31.805 31.9747 31.6749 32.0006 31.5435 32.0006C31.4121 32.0006 31.282 31.9747 31.1606 31.9245C31.0392 31.8742 30.9289 31.8005 30.836 31.7076L22.5435 23.4138L14.251 31.7076C14.0634 31.8952 13.8089 32.0006 13.5435 32.0006C13.2782 32.0006 13.0237 31.8952 12.836 31.7076C12.6484 31.5199 12.543 31.2654 12.543 31.0001C12.543 30.7347 12.6484 30.4802 12.836 30.2926L21.1298 22.0001L12.836 13.7076C12.6484 13.5199 12.543 13.2654 12.543 13.0001C12.543 12.7347 12.6484 12.4802 12.836 12.2926C13.0237 12.1049 13.2782 11.9995 13.5435 11.9995C13.8089 11.9995 14.0634 12.1049 14.251 12.2926L22.5435 20.5863L30.836 12.2926C31.0237 12.1049 31.2782 11.9995 31.5435 11.9995C31.8089 11.9995 32.0634 12.1049 32.251 12.2926C32.4387 12.4802 32.5441 12.7347 32.5441 13.0001C32.5441 13.2654 32.4387 13.5199 32.251 13.7076L23.9573 22.0001L32.251 30.2926Z" fill="#DA251C"/>
                                </svg>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <StationOnMap
                                :mapCenter="station.coordinates || [57.153165835548556, 65.56351504916005]"
                            />
                        </v-card-text>
                    </div>
                </v-card>
            </div>
        </v-dialog>
        <!-- <Dialog
            v-if="isShownMapDialog"
            :action-items="mapDialogActionItems"
            :show.sync="isShownMapDialog"
            type="full-screen"
            :title="station.name">
            <StationOnMap
                :mapCenter="station.coordinates || [57.153165835548556, 65.56351504916005]"
            />
        </Dialog> -->
    </div>
</template>

<script>
    import StationOnMap from './StationsOnMap.vue'

    export default {
        name: 'StationItem',

        components: { StationOnMap },

        props: {
            color: { type: String },
            distance: { type: [String, Number] },
            station: { type: Object },
            selected: Boolean,
            view: Boolean,
        },

        data() {
            return {
                isShownMapDialog: false,
            }
        },

        computed: {
            clearPhone() {
                const phone = this.station?.phone
                const clearPhone = phone.replace(/[^0-9+,]/g, '')

                return `tel:${clearPhone}`
            },
            mapDialogActionItems() {
                return [
                    {
                        text: 'Отмена',
                        click: () => {
                            this.isShownMapDialog = false
                        },
                    },
                ]
            },
        },

        methods: {
            selectStation() {
                this.$emit('select', this.station.id)
            },
            showOnMap() {
                this.isShownMapDialog = true
            },
        },
    }
</script>

<style scoped>
    .station-card {
        max-width: 100%;
        width: 356px;
        height: 380px;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0px;

        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 0px;
        padding: 12px 16px;

        border: 1.5px solid rgb(228, 228, 228);
        border-radius: 12px;
    }
    .mobile .station-card {
        width: calc(100vw - 24px);
    }
    .station-card.selected {
        border-color: #DA251C;
    }
    .station-picture {
        border-radius: 10px;
        margin-bottom: 12px;
    }
    .station-description {
        margin-bottom: 14px;
    }
    .station-description-title {
        color: rgb(54, 57, 59);
        font-size: 16px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .station-description-text {
        color: rgb(54, 57, 59);
        font-size: 14px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .station-description-time {
        color: rgb(54, 57, 59);
        font-size: 14px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .station-actions {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .station-select-btn {
        max-width: 80%;
        width: 262px;
        height: 54px !important;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 16px 40px 16px 40px;

        flex: none;
        order: 0;
        flex-grow: 0;
        /* margin: 0px 8px; */

        box-sizing: border-box;
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: #fff !important;
        color: #DA251C;

        font-size: 16px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
    }
    .v-btn.station-select-btn.selected {
        border: 1.5px solid rgb(232, 232, 232);
        border-radius: 10px;
        background-color: rgb(232, 232, 232) !important;
    }
    .v-btn.station-select-btn.selected .btn-text {
        color: rgb(143, 143, 143);
    }
    .station-select-btn .btn-text {
        color: rgb(54, 57, 59);
    }
    .station-select-btn:hover {
        background: #fff !important;
        border: 1.5px solid #DA251C;
    }
    .station-map-btn {
        width: 54px !important;
        height: 54px;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        /* padding: 16px 40px 16px 40px; */

        flex: none;
        order: 1;
        flex-grow: 0;
        /* margin: 0px 8px; */

        box-sizing: border-box;
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: rgb(218, 37, 28);
        padding: 0 !important;
    }
    .station-select-btn.view:hover {
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: rgb(218, 37, 28) !important;
    }
    .station-select-btn.view:hover .btn-text{
        color: white;
    }
    .station-map-btn.view {
        background-color: white;
    }
    .station-map-btn.view:hover {
        background: rgb(218, 37, 28) !important;
    }
    .station-map-btn.view:hover svg path {
        stroke: white;
    }
    .dialog-card {
        width: 100vw;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
</style>
